// extracted by mini-css-extract-plugin
module.exports = {"boxIcon":"RelatedObjectsFilter_boxIcon__yTRra"};